import React from 'react';

// todo make this prettier, add animation/spinner or something

export default function Loading() {
  return <div>Loading...</div>;
}
